import { useState, useMemo } from "react";
import { UserInterfaceAccessGuardContext } from "../user-interface-access-guard-context";
import { CurrentUserInfoType } from "../types";
import { UserInterfaceAccessGuardProviderProps } from "./types";

export const UserInterfaceAccessGuardProvider = ({
  children,
}: UserInterfaceAccessGuardProviderProps) => {
  const [currentUserInfo, setCurrentUserInfo] = useState<CurrentUserInfoType>(
    {}
  );

  const contextValue = useMemo(
    () => ({
      currentUserInfo,
      setCurrentUserInfo,
    }),
    [currentUserInfo]
  );

  return (
    <UserInterfaceAccessGuardContext.Provider value={contextValue}>
      {children}
    </UserInterfaceAccessGuardContext.Provider>
  );
};
